// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1Ooc-","label":"LabeledBox_label__1t4X9"};